exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".false-tip-wrap{position:fixed;left:0;top:0;width:100%;background-color:#fff;display:-ms-flexbox;display:flex;-ms-flex-direction:column;flex-direction:column;-ms-flex-align:center;align-items:center;-ms-flex-pack:center;justify-content:center;height:100%;padding:0 10%;color:#999;font-size:.48rem;box-sizing:border-box;z-index:2}.false-tip-wrap .false-img-wrap{display:block;margin-bottom:1.6rem}.false-tip-wrap .false-img-wrap>img{height:3.66667rem;margin:0 auto}.false-tip-wrap>.false-txt{font-size:.48rem;color:#999}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-rewriter.js!./~/sass-loader!./~/vue-loader/lib/selector.js?type=style&index=0!./web/components/error/error.vue
// module id = 148
// module chunks = 0 3 7 8 9 10 12 13 16 17 23 24 25 30 35 36 37 38 39 40 41 44 49 52 53 54 55 74 77 92 93 94 95 97 100 101 103 104 105 106 109 111 114 118 119 120 121 125 162 164 165 166 168 169 170 171